// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1YmbS","OrderButton":"BuildControls_OrderButton___M-Du","orderButtonEnable":"BuildControls_orderButtonEnable__2F3M-"};